import { ElementType } from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { ContainerProps } from './carousel.types';
import { breakpoints } from 'common/styles/breakpoints';

export const Container: ElementType = styled.div<ContainerProps>`
  display: grid;
  justify-content: start;
  grid-auto-flow: column;
  grid-gap: var(--grid-gap);
  width: 100%;
  height: 100%;
  overflow: hidden;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-snap-type: ${({ inScrollNow }) => (inScrollNow ? 'none' : 'x mandatory')};
  &::-webkit-scrollbar {
    display: none;
  }
  overflow-x: scroll;
  ${breakpoints.only.tablet} {
    -webkit-overflow-scrolling: touch;
  }
  ${breakpoints.only.mobile} {
    -webkit-overflow-scrolling: touch;
    scroll-padding: var(--layout-gap);
  }
`;

export const SafariScrollGap = styled.div`
  width: 4px;
`;

export const wrapperStyles = css`
  position: relative;
`;
